module.exports = __webpack_public_path__ + "static/media/map-pin.38f438fa.svg";